"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KycRoutes = void 0;
const route_1 = require("../route");
/** @deprecated: User Compliance Routes */
class KycRoutes extends route_1.Route {
    constructor() {
        super('id_document');
    }
    /** @deprecated: Use sdk.complianceRoutes.idDocument.create */
    upload(url, md5, proofUrl) {
        return this.post('/upload', {
            url,
            md5,
            proofUrl
        });
    }
    /** @deprecated: Use sdk.complianceRoutes.idDocument.update  */
    info(docId, idNumber, idType, idCountry) {
        return this.post('/info', {
            docId,
            idNumber,
            idType,
            idCountry
        });
    }
    /** @deprecated: Use sdk.complianceRoutes.idDocument.bvn */
    bvn(number, selfieUrl, dob) {
        return this.post('/bvn', {
            bvn: number,
            selfieUrl,
            dob
        });
    }
    /** @deprecated: Use sdk.complianceRoutes.userInfo.getVerificationStatus */
    getVerificationStatus() {
        return this.get('/verification/status');
    }
    /** @deprecated: Use sdk.complianceRoutes.userInfo.getVerificationStatus */
    getFullVerificationStatus() {
        return this.get('/verification/status/full');
    }
    /** @deprecated: Use sdk.complianceRoutes.userInfo.updateUserInfo */
    updateBasicDetails(firstName, lastName, dateOfBirth) {
        return this.post('/basic', { firstName, lastName, dateOfBirth });
    }
    /** @deprecated: Use sdk.complianceRoutes.userInfo.updateAddress */
    updateAddress(address) {
        return this.post('/address', address);
    }
}
exports.KycRoutes = KycRoutes;
//# sourceMappingURL=kyc.js.map